export default __webpack_public_path__ + "static/insta-hotels-4-1e46b8573c766cf0bc0d7d95128fd5ac.jpg";